const ICircle = ({ className = 'h-4 w-4' }) => (
  <svg
    id="info"
    version="1.1"
    viewBox="0 0 24 24"
    className={className}
    role="presentation"
    aria-hidden={true}
  >
    <title>Info</title>
    <path
      fill="currentColor"
      d="M12,2 C14.750496,2 17.1261685,2.9840358 19.0710672,4.92893169 C21.015963,6.87382794 22,9.24950238 22,12 C22,14.7504952 21.0159633,17.1261679 19.0710666,19.0710677 C17.1261679,21.0159633 14.7504952,22 12,22 C9.24950238,22 6.87382794,21.015963 4.9289311,19.0710666 C2.9840358,17.1261685 2,14.750496 2,12 C2,9.24950154 2.98403618,6.87382732 4.92893166,4.92893155 C6.87382732,2.98403618 9.24950154,2 12,2 Z M12,4 C9.77993442,4 7.91296799,4.77332258 6.34314522,6.34314511 C4.77332258,7.91296799 4,9.77993442 4,12 C4,14.2200633 4.77332232,16.0870285 6.34314507,17.6568535 C7.91296869,19.2266767 9.77993544,20 12,20 C14.2200623,20 16.0870278,19.2266769 17.656853,17.6568541 C19.2266769,16.0870278 20,14.2200623 20,12 C20,9.77993544 19.2266767,7.91296869 17.6568541,6.34314567 C16.0870285,4.77332232 14.2200633,4 12,4 Z M11.9999993,10.9999995 C12.552284,10.9999995 12.9999993,11.4477148 12.9999993,11.9999995 L12.9999993,11.9999995 L12.9999993,15.9999995 C12.9999993,16.5522843 12.552284,16.9999995 11.9999993,16.9999995 C11.4477145,16.9999995 10.9999993,16.5522843 10.9999993,15.9999995 L10.9999993,15.9999995 L10.9999993,11.9999995 C10.9999993,11.4477148 11.4477145,10.9999995 11.9999993,10.9999995 Z M12,7 C12.5522847,7 13,7.44771525 13,8 C13,8.55228475 12.5522847,9 12,9 C11.4477153,9 11,8.55228475 11,8 C11,7.44771525 11.4477153,7 12,7 Z"
    ></path>
  </svg>
);

ICircle.propTypes = {
  className: PropTypes.string,
};

export default ICircle;
